var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('OButton',{attrs:{"to":_vm.to,"theme":"primary","type":"button"}},[_vm._v("\n  Back\n")])}
var staticRenderFns = []

export { render, staticRenderFns }